import { AppActions } from './action-types';

const appMounted = () => ({
  type: AppActions.APP_MOUNTED,
});

const fetchTranslations = (locale) => ({
  type: AppActions.FETCH_TRANSLATIONS,
  payload: locale,
});

export {
  appMounted,
  fetchTranslations,
};
